<script setup>
import TriggerConfig from '../panels/TriggerConfig.vue'
import EmailConfig from '../panels/EmailConfig.vue'
import PushConfig from '../panels/PushConfig.vue'
import AddTagConfig from '../panels/AddTagConfig.vue'
import ConditionBuilder from '../panels/ConditionBuilder.vue'
import DelayConfig from '../panels/DelayConfig.vue'
import WaitUntilConfig from '../panels/WaitUntilConfig.vue'
import SplitConfig from '../panels/SplitConfig.vue'
import GoalConfig from '../panels/GoalConfig.vue'
import WaitForDateConfig from '../panels/WaitForDateConfig.vue'

const props = defineProps({
    node: {
        type: Object,
        default: null,
    },
})

const emit = defineEmits(['update:config'])

const panelMap = {
    trigger: TriggerConfig,
    action_email: EmailConfig,
    action_push: PushConfig,
    action_add_tag: AddTagConfig,
    condition: ConditionBuilder,
    delay: DelayConfig,
    wait_until: WaitUntilConfig,
    wait_for_date: WaitForDateConfig,
    split: SplitConfig,
    goal_check: GoalConfig,
}

const nodeLabelMap = {
    trigger: 'Trigger',
    action_email: 'Send Email',
    action_push: 'Push Notification',
    action_add_tag: 'Add Tag',
    condition: 'Condition',
    delay: 'Delay',
    wait_until: 'Wait Until',
    wait_for_date: 'Wait for Date',
    split: 'A/B Split',
    goal_check: 'Goal Exit',
    exit_allow_reentry: 'Exit and Allow Re-entry',
}

function getPanel(type) {
    return panelMap[type] ?? null
}

function getNodeLabel(type) {
    return nodeLabelMap[type] ?? type
}

function onConfigUpdate(config) {
    emit('update:config', config)
}
</script>

<template>
    <aside class="node-config-panel" v-if="node">
        <div class="node-config-panel__header">
            <span class="node-config-panel__title">{{ getNodeLabel(node.type) }}</span>
            <span class="node-config-panel__id">{{ node.id }}</span>
        </div>
        <div class="node-config-panel__body">
            <component
                :is="getPanel(node.type)"
                v-if="getPanel(node.type)"
                :node="node"
                @update:config="onConfigUpdate"
            />
            <div v-else class="node-config-panel__no-config">
                <p>No configuration options for this node type.</p>
            </div>
        </div>
    </aside>
</template>

<style scoped>
.node-config-panel {
    width: 300px;
    background: #f9fafb;
    border-left: 1px solid #e5e7eb;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    overflow-y: auto;
}
.node-config-panel__header {
    padding: 14px 16px 10px;
    border-bottom: 1px solid #e5e7eb;
    background: white;
}
.node-config-panel__title {
    display: block;
    font-weight: 700;
    font-size: 14px;
    color: #111827;
}
.node-config-panel__id {
    font-size: 10px;
    color: #9ca3af;
}
.node-config-panel__body {
    padding: 12px;
    flex: 1;
}
.node-config-panel__no-config {
    font-size: 13px;
    color: #6b7280;
    text-align: center;
    margin-top: 20px;
}
</style>
